module.exports = __webpack_public_path__ + "static/img/success.2a3a10d.gif";


//////////////////
// WEBPACK FOOTER
// ./static/icons/success.gif
// module id = 9zv/
// module chunks = 1